<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />报警对比分析 <slot name="right"></slot></h3>
    <Table :data='tableData' :columns='columns'>
      <template slot-scope="{ row }" slot="alarmTotal">
        <span>{{ row.alarmTotal }}次</span>
      </template>
      <template slot-scope="{ row }" slot="lastTotal">
        <span>{{ row.lastTotal }}次</span>
      </template>
      <template slot-scope="{ row }" slot="contrastRate">
        <Icon v-if="row.contrast === 0" type="md-remove" color="blue" size="15" />
        <Icon v-else-if="row.contrast === 1" type="md-arrow-round-up" color="red" size="15" />
        <Icon v-else-if="row.contrast === 2" type="md-arrow-round-down" color="green" size="15"/>
        {{ type[row.contrast] }}{{ row.contrastRate }}%
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  data() {
    return {

      tableData: [
        {
          name: "张山",
          sex: "男",
          age: 23,
        },
        {
          name: "张山",
          sex: "男",
          age: 23,
        },
        {
          name: "张山",
          sex: "男",
          age: 23,
        },
        {
          name: "张山",
          sex: "男",
          age: 23,
        },
        {
          name: "张山",
          sex: "男",
          age: 23,
        },
      ],
      columns: [
        {
          title: "报警类型",
          key: "alarmEvent",
        },
        {
          title: "本周期报警",
          key: "alarmTotal",
          slot: 'alarmTotal',
        },
        {
          title: "上周期报警",
          key: "lastTotal",
          slot: 'lastTotal',
        },
        {
          title: "同比增长率",
          key: "contrastRate",
          slot: 'contrastRate',
        },
      ],
      type: {
        0: "持平",
        1: "上升",
        2: "下降",
      },
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countContrast",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data=res.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i].contrast2=this.type[data[i].contrast]
        }
        console.log(data);
        this.tableData=data;
      });
    },
  },
  mounted() {
    
  },
};
</script>
<style>
#kdkdkdk {
  width: 100%;
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/baojingduibi.vue